export class ReactRouterBridgeNotInitializedError extends Error {
    constructor(message = 'React Router Bridge not initialized.') {
        super(message);
        this.name = 'ReactRouterBridgeNotInitializedError';
    }
}
